import { render, staticRenderFns } from "./CommunityActivityList.vue?vue&type=template&id=0704680e&scoped=true&"
import script from "./CommunityActivityList.vue?vue&type=script&lang=js&"
export * from "./CommunityActivityList.vue?vue&type=script&lang=js&"
import style0 from "./CommunityActivityList.vue?vue&type=style&index=0&id=0704680e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704680e",
  null
  
)

export default component.exports